module.exports = __webpack_public_path__ + "img/android_tutorial03.53f110e8.jpg";